import { useRooms } from "@/hooks/useRooms";
import { RoomCard } from "@/components/RoomCard";

export function HomePage() {
  const { data: rooms, isLoading, error } = useRooms();

  return (
    <>
      <section className="bg-surface-warm">
        <div className="mx-auto max-w-container px-6 py-16 text-center md:py-24">
          <p className="mb-3 text-caption font-medium uppercase tracking-widest text-primary">
            Tanzschule Tanzraum · Köln
          </p>
          <h1 className="mb-5 font-display text-h1 uppercase text-primary md:text-display">
            Finde deinen Raum
          </h1>
          <p className="mx-auto max-w-2xl text-lead text-ink-soft">
            Vier professionelle Tanzräume in Köln für Einzeltraining, Workshop oder Proben.
            Buchen können ausschließlich ausgewählte, mit der Tanzschule assoziierte
            Tanzlehrer:innen. Verfügbarkeit live im Kalender prüfen, in zwei Schritten
            anfragen, persönliche Bestätigung von Charlie.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-container px-6 py-16 md:py-20">
        {isLoading && (
          <p className="text-body-sm text-ink-muted">Räume werden geladen…</p>
        )}
        {error && (
          <p className="text-body-sm text-danger">
            Räume konnten nicht geladen werden. Bitte später erneut versuchen.
          </p>
        )}

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {rooms?.map((room) => (
            <RoomCard key={room.id} room={room} />
          ))}
        </div>
      </section>

      <section className="bg-surface-warm">
        <div className="mx-auto flex max-w-container flex-col items-start gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:py-16">
          <div>
            <h2 className="mb-2 font-display text-h2 uppercase text-primary">
              Noch Fragen zum Raum?
            </h2>
            <p className="text-body text-ink-soft">
              Schreib Charlie direkt, auch bei Sonderwünschen wie Workshop-Wochenenden.
            </p>
          </div>
          <a
            href="mailto:info@tanzschule-tanzraum.de"
            className="inline-flex items-center gap-2 rounded border-2 border-primary px-6 py-3 text-body font-semibold text-primary transition-colors hover:bg-primary hover:text-white"
          >
            Kontakt aufnehmen
          </a>
        </div>
      </section>
    </>
  );
}
